module.exports = __webpack_public_path__ + "media/components/src/assets/images/method/visa-8a2b8f6f3869d47b0c204f8c8d535465.png";